<template lang="pug">

    tr
        // ZMÜK-ID
        td
            router-link(v-bind:to='getRouterConfig(jobOffers[0])') {{ jobProduct.zmuekId }}
        td {{ status }}
        td {{ jobProductType.name }}
        td
            router-link.ui.tiny.label(
                v-for='offer in jobOffers'
                v-bind:key='offer.id'
                v-bind:to='getRouterConfig(offer)'
                v-tooltip='"Auftrag zur Variante ist neu/unbearbeitet"'
            ) V{{ getOfferVariant(offer).number }}
        td {{ validUntil }}
        td {{ deliveryDate }}
        td -
        td {{ jobMediaProductionPerson ? jobMediaProductionPerson.firstName + ' ' + jobMediaProductionPerson.lastName : '-' }}

</template>


<script>
    import * as R from 'ramda'
    import { to_ddmmyyyy } from '@/utils/date'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            deliveryDate() {
                return R.ifElse(
                    R.isNil,
                    R.always('-'),
                    to_ddmmyyyy
                )(this.jobProduct.deliveryDate)
            },

            jobOffers() {
                return this.offerModels.filter(offer => offer.job === this.jobModel.id)
            },

            jobMediaProductionPerson() {
                if (!this.jobMediaProductionUser) return null
                return this.mediaProductionPersonModels
                    .find(person => person.id === this.jobMediaProductionUser.person) || null
            },

            jobMediaProductionUser() {
                return this.mediaProductionUserModels
                    .find(user => user.id === this.jobProduct.mediaProduction)
            },

            jobProduct() {
                //noinspection JSPotentiallyInvalidTargetOfIndexedPropertyAccess
                return this.productModels
                    .find(product => product.id === this.jobVariants[0].product)
            },

            jobProductType() {
                return this.productTypes
                    .find(type => type.id === this.jobProduct.type)
            },

            jobVariants() {
                return this.jobOffers
                    .map(offer => this.variantModels.find(variant => variant.id === offer.variant))
            },

            status() {
                return R.cond([
                    [ R.equals("NEW"), R.always("Neu") ],
                    [ R.equals("PENDING"), R.always("Offen") ],
                    [ R.equals("ACCEPTED"), R.always("Bestätigt") ],
                    [ R.equals("IN_PRODUCTION"), R.always("Produktion") ],
                    [ R.equals("DELIVERED"), R.always("Versendet") ],
                    [ R.equals("QA"), R.always("Qualitätssicherung") ],
                    [ R.equals("DECLINED"), R.always("Abgelehnt") ],
                    [ R.equals("COMPLETED"), R.always("Abgeschlossen") ],
                    [ R.equals("ARCHIVE"), R.always("Archiviert") ],
                    [ R.T, R.always("Unbekannt") ]
                ])(this.jobModel.status)
            },

            validUntil() {
                return to_ddmmyyyy(this.jobModel.validUntil)
            }

        },

        methods: {

            getRouterConfig(offerModel) {
                return {
                    name: "jobs/update",
                    params: {
                        jobId: this.jobModel.id,
                        offerId: offerModel.id
                    }
                }
            },

            getOfferVariant(offer) {
                return this.jobVariants.find(variant => variant.id === offer.variant)
            }

        },

        props: {

            jobModel: {
                type: Object,
                required: true
            },

            mediaProductionPersonModels: {
                type: Array,
                required: true
            },

            mediaProductionUserModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            productModels: {
                type: Array,
                required: true
            },

            // TODO pruefen ob nicht `productTypeModels` heissen müsste
            productTypes: {
                type: Array,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
